import React, { useState, useRef, useEffect } from 'react'
import { tokens } from '../../styles/desertFloraTheme'

const styles = {
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 2
  },
  input: {
    fontFamily: tokens.fontMono,
    fontSize: 12,
    fontWeight: 500,
    width: 40,
    textAlign: 'right',
    background: 'transparent',
    border: '1px solid transparent',
    borderRadius: 6,
    padding: '3px 4px',
    color: tokens.ink,
    outline: 'none',
    boxSizing: 'border-box'
  },
  inputFocused: {
    borderColor: tokens.primary,
    background: tokens.surface,
    boxShadow: '0 0 0 2px rgba(31,94,58,.14)'
  },
  suffix: {
    fontSize: 11,
    color: tokens.ink3,
    fontFamily: tokens.fontMono
  }
}

const MarkupCell = ({ value, onChange, disabled }) => {
  const [localValue, setLocalValue] = useState(String(value ?? 0))
  const [focused, setFocused] = useState(false)
  const inputRef = useRef(null)

  useEffect(() => {
    if (!focused) {
      setLocalValue(String(value ?? 0))
    }
  }, [value, focused])

  const commit = () => {
    const parsed = Number(localValue)
    if (!isNaN(parsed) && onChange) {
      onChange(parsed)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      commit()
      if (inputRef.current) inputRef.current.blur()
    }
  }

  const handleBlur = () => {
    setFocused(false)
    commit()
  }

  const containerStyle = {
    ...styles.container,
    ...(disabled ? { opacity: 0.5, pointerEvents: 'none' } : {})
  }

  const inputStyle = {
    ...styles.input,
    ...(focused ? styles.inputFocused : {})
  }

  return (
    <span style={containerStyle}>
      <input
        ref={inputRef}
        type="number"
        style={inputStyle}
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        disabled={disabled}
      />
      <span style={styles.suffix}>%</span>
    </span>
  )
}

export default MarkupCell
